function HomepageController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}
	
	
	function initReferenceCardsTouch(){
		$('.reference-item a').click(function(e){
			e.preventDefault();
			var link = $(this);
			if(link.hasClass('hover')) {
				window.location.assign(link.attr('href'));
			}
			link.addClass('hover');
		});
	}
	
   
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// init
			var introClaim = new IntroClaim($('#intro-claim'));
			
			if(isTouchDevice()) {
				initReferenceCardsTouch();
			}

			_this.inited = true;
		}
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
